import { Stack } from '@mui/material';

import { SubpageLayout } from '@/components/architecture/Layout/SubpageLayout';
import { Button } from '@/components/form/baseInputs/Button/Button';
import { ActionCard } from '@/components/layout/ActionCard/ActionCard';
import { useFeedback } from '@/components/notifications/Feedback/useFeedback';
import { useReportError } from '@/hooks/useReportError';
import { $downloadStreamedFile } from '@/modules/files/utils/fileUtils';

import { useGenerateDocumentSummariesReportMutation } from './graphql/AdminDocumentSummariesReportPage.generated';

export function AdminDocumentSummariesReportPage() {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();
  const [generateReport, { loading }] =
    useGenerateDocumentSummariesReportMutation({
      onError: (error) => {
        reportError('Could not generate document summaries report', error);
        showFeedback(
          'An error occurred while generating the report. Please try again.'
        );
      },
      onCompleted: async (data) => {
        try {
          await $downloadStreamedFile(
            `/api/download/file?token=${data.exportDocumentSummariesExcel.token}`
          );
        } catch (error) {
          reportError(
            'Could not download document summaries report',
            error instanceof Error ? error : new Error(String(error))
          );
          showFeedback(
            'An error occurred while downloading the report. Please try again.'
          );
        }
      },
    });

  const handleGenerateReport = async () => {
    await generateReport();
  };

  return (
    <SubpageLayout heading="Reporting">
      <Stack maxWidth={400}>
        <ActionCard
          heading="Document summaries report"
          description="Download document summaries for the households you can access."
          variant="reporting"
          actions={
            <Button
              variant="primary"
              size="sm"
              loading={loading}
              onClick={handleGenerateReport}
            >
              Generate report
            </Button>
          }
        />
      </Stack>
    </SubpageLayout>
  );
}
